export const getPath = ({ audience, tag }) =>
  ['/ratgeber', audience && `/a/${audience}`, tag && `/t/${tag}`]
    .filter(Boolean)
    .join('')
